import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import PetWeight from './PetWeight.js';

var PetWeightComponent = function PetWeightComponent(_ref) {
  var onPetWeightUpdated = _ref.onPetWeightUpdated,
    onError = _ref.onError,
    originalPetWeight = _ref.originalPetWeight;
  var _useState = useState(originalPetWeight),
    _useState2 = _slicedToArray(_useState, 2),
    petWeight = _useState2[0],
    setPetWeight = _useState2[1];
  var petWeightUpdated = function petWeightUpdated(newWeight) {
    onPetWeightUpdated(newWeight);
    setPetWeight(newWeight);
  };
  useEffect(function () {
    if (originalPetWeight !== undefined) {
      setPetWeight(originalPetWeight);
      onPetWeightUpdated(originalPetWeight);
    }
  }, [originalPetWeight]);
  return /*#__PURE__*/React.createElement(PetWeight, {
    petWeightController: {
      newPetWeight: petWeight,
      setNewPetWeight: petWeightUpdated
    },
    setNewPetWeightError: onError,
    showWeight: true
  });
};
PetWeightComponent.propTypes = {
  onPetWeightUpdated: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  originalPetWeight: PropTypes.string.isRequired
};

export { PetWeightComponent as default };
